/* eslint-disable indent */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import {
  East,
  Event,
  Task,
} from '@mui/icons-material';
import NoteAlt from '@mui/icons-material/NoteAlt';
import {
  Avatar,
  Box,
  Chip,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Tooltip,
  Typography,
} from '@mui/material';
import {
  alpha,
  useTheme,
} from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getColorForBillableStatus } from '../../../../../../../../pages/billing/components/BillablesTable';
import { primary } from '../../../../../../../../utils/brandColors';

const TaskOptionComponent = ({
  eventTemplate,
  onSelectTask,
  onSelectCalendarEvent,
}) => {
  const theme = useTheme();
  const selectedBarn = useSelector((state) => state.barn.selectedBarn);
  const eventData = useSelector((state) => state.eventData.eventData);
  const isCalendarEvent = eventTemplate.tags.find((ett) => ett.id === selectedBarn.barnMetadata.eventTaskTypeTagId);

  const getEDNameFromId = (id) => (eventData.find((ed) => ed.id === id) || { name: 'Unknown' }).name;
  const color = (eventTemplate.eventDataDefaultValues && eventTemplate.eventDataDefaultValues.calendarDisplayColor) || primary[500];
  const accentSurface = alpha(color, theme.palette.mode === 'dark'
    ? 0.50
    : 0.08);
  const accentBorder = alpha(color, theme.palette.mode === 'dark'
    ? 0.65
    : 0.35);
  const metadata = (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {
          eventTemplate.eventDataDefaultValues[
          getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId)] && (
            <Tooltip title="Billable amount at task completion">
              <Chip
                size="small"
                sx={{ mr: 1 }}
                variant="outlined"
                color={getColorForBillableStatus({ status: eventTemplate.eventDataDefaultValues['Billable Status'] || 'Open' })}
                // icon={((eventTemplate.eventDataDefaultValues['Billable Receivable'] || 'yes') === 'yes')
                //   ? <AttachMoney />
                //   : <MoneyOff />}
                label={`$${eventTemplate.eventDataDefaultValues[
                  getEDNameFromId(selectedBarn.barnMetadata.horseBillablePriceEventDataId)]}`}
              />
            </Tooltip>
          )
        }
        {
          eventTemplate.eventDataDefaultValues[
          getEDNameFromId(selectedBarn.barnMetadata.horseNoteTypeEventDataId)] && (
            <Tooltip title="Horse note to be posted along with task completion">
              <Chip
                size="small"
                icon={<NoteAlt />}
                label={`${eventTemplate.eventDataDefaultValues[getEDNameFromId(selectedBarn.barnMetadata.horseNoteTypeEventDataId)] === 'Note'
                  ? ''
                  : eventTemplate.eventDataDefaultValues[getEDNameFromId(selectedBarn.barnMetadata.horseNoteTypeEventDataId)]} Horse Note`}
              />
            </Tooltip>
          )
        }
      </Box>
      {eventTemplate.description && <Box><Typography varian="caption" sx={{ fontSize: 12 }}>{eventTemplate.description}</Typography></Box>}
    </Box>
  );
  return (
    <ListItemButton
      key={`most_used_${eventTemplate.id}`}
      dense
      onClick={() => {
        isCalendarEvent
          ? onSelectCalendarEvent(eventTemplate)
          : onSelectTask(eventTemplate)
      }}
      sx={{
        mx: 0,
        mb: 1,
        pt: 0,
        pb: 0,
        px: 1,
        backgroundColor: 'rgb(244, 244, 244)',
        border: '1px solid #CECECE',
        borderLeft: `8px solid ${color}`,
        borderRadius: '6px',
        '&:hover': {
          transform: 'translateY(-1px)',
          backgroundColor: accentSurface,
        },
      }}
    >
      <ListItemAvatar
        sx={{
          minWidth: 'auto',
          mr: 1,
        }}
      >
        <Avatar
          sx={{
            backgroundColor: 'rgb(244, 244, 244)',
            color,
            width: 46,
            height: 46,
          }}
        >
          {isCalendarEvent
            ? (
              <Event
                sx={{ color: `${color} !important` }}
              />
            )
            : (
              <Task
                sx={{ color: `${color || primary[500]} !important` }}
              />
            )}
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primaryTypographyProps={{
          component: 'div',
          color: (t) => t.palette.text.primary,
        }}
        primary={(
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: '16px',
              color: (t) => t.palette.text.primary,
            }}
          >{eventTemplate.name}
          </Typography>
        )}
        secondaryTypographyProps={{
          component: 'div',
          sx: { color: (t) => t.palette.text.primary },
        }}
        secondary={metadata}
      />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          maxWidth: '50%',
          textAlign: 'right',
        }}
      >
        <East
          sx={{
            ml: 2,
            color: accentBorder,
          }}
        />
      </Box>
    </ListItemButton>
  )
}

TaskOptionComponent.propTypes = {
  eventTemplate: PropTypes.object.isRequired,
  onSelectTask: PropTypes.func.isRequired,
  onSelectCalendarEvent: PropTypes.func.isRequired,
};

TaskOptionComponent.defaultProps = {};

export default TaskOptionComponent;
